module.exports = __webpack_public_path__ + "static/media/menu_open.d1324676.svg";